module.exports = __webpack_public_path__ + "img/cheeks.52f591fc.svg";